import { Link } from "react-router-dom";

const cards = [
    {
        to: "/gt3x/archiv/season1/pro",
        title: "Standings",
        pillClass: "pill--pro",
        pillText: "PRO",
        sub: "Archivierte PRO-Gesamtwertung der Season 1",
    },
    {
        to: "/gt3x/archiv/season1/am",
        title: "Standings",
        pillClass: "pill--am",
        pillText: "AM",
        sub: "Archivierte AM-Gesamtwertung der Season 1",
    },
    {
        to: "/gt3x/archiv/season1/team",
        title: "Standings",
        pillClass: "pill--team",
        pillText: "TEAM",
        sub: "Archivierte Teamwertung der Season 1",
    },
    {
        to: "/gt3x/archiv/season1/marken",
        title: "Standings",
        pillClass: "pill--marke",
        pillText: "MARKE",
        sub: "Archivierte Markenwertung der Season 1",
    },
    {
        to: "/gt3x/archiv/season1/results",
        title: "Ergebnisse",
        pillClass: "pill--int",
        pillText: "RACEDAY",
        sub: "Archivierte Race-, Qualy- und Practice-Ergebnisse",
    },
];

export default function ArchiveSeason1() {
    return (
        <>
            <div className="card overview-card-top">
                <h1>Archiv – Season 1</h1>
                <p className="muted results-subtitle">
                    Auswahl der archivierten Standings und Rennergebnisse.
                </p>
            </div>

            <div className="grid4">
                {cards.map((card) => (
                    <Link key={card.to} to={card.to} className="grid-card" style={{ textDecoration: "none" }}>
                        <div className="grid-card__info">
                            <div className="grid-card__title">
                                {card.title} <span className={`pill ${card.pillClass}`}>{card.pillText}</span>
                            </div>
                            <div className="grid-card__sub">{card.sub}</div>
                        </div>
                    </Link>
                ))}
            </div>
        </>
    );
}